<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<!-- Input Examples -->
		<FormItem prop="trackName">
			<FormItem prop="trackName">
			<Input style="width: 260px;" type="text" v-model="formInline.KeyWord" :placeholder="formInline.KeyType">
			<span slot="prepend">
				<Select placeholder="" style="width: 100px;" v-model="formInline.KeyType">
					<Option value='Name'>救援点</Option>
					<Option value='Contacter'>联系人</Option>
					<Option value='PhoneNo'>联系电话</Option>
	                <Option value='Address'>联系地址</Option>
				</Select>
			</span>
			</Input>
			</FormItem>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
		</FormItem>
		<div style="float: right;">
			<Button type="primary" @click="$emit('show','add')" v-if="hasWidgets('add')">{{ $t('Common.Add') }}</Button>
		</div>
	</Form>
</template>

<script>
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					KeyType: 'Name',
					KeyWord: '',
				}
				
			};
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId
			// 	}
			// 	return param
			// },
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
		},
	}
</script>

<style>
</style>
